import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

export const useAddressValidationSchema = () => {
  const { t } = useTranslation();

  const addressValidationSchema = useMemo(
    () =>
      Yup.string()
        .test(
          'validAddressFormat',
          t('Please select a valid address from Google Places suggestions'),
          (value, context) => {
            // If editing an existing entity (either through currentLegalEntity or having existing data)
            if (
              context?.parent?.currentLegalEntity ||
              (context?.parent?.legal_name && context?.parent?.tax_number)
            ) {
              return !!value?.trim();
            }

            // For new entities, validate Google Places data
            const hasValidGooglePlace = !!(
              context?.parent?.dataGooglePlaces?.formatted_address &&
              context?.parent?.dataGooglePlaces?.place_id
            );

            const hasAddress = !!value?.trim();
            return hasValidGooglePlace && hasAddress;
          }
        )
        .required(t('Please enter an address')),
    [t]
  );

  return { addressValidationSchema };
};
